import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiBasicCard } from 'noddi-ui-web';
import { InstructionRow } from '../Common/InstructionRow';

/**
 * `isStationary` hides the arrival/queue row: a stationary customer drives to
 * the station, so "estimated arrival time" and "next on the list" are wrong.
 */
export const BookingProposalNotRecallNextSteps = ({ isStationary = false }: { isStationary?: boolean }) => (
  <NoddiBasicCard className='flex flex-col gap-3'>
    <p className='mb-2 text-xl'>
      <Trans>What happens next?</Trans>
    </p>
    <InstructionRow
      icon='Check'
      title={t`Confirmation`}
      description={t`You'll receive an SMS confirmation with your booking details within the next few minutes. If you need to change the time of your booking, you can do so through your account.`}
    />
    {!isStationary && (
      <InstructionRow
        icon='MessageSquare'
        title={t`Communication`}
        description={t`The day before your appointment, you'll receive an SMS with a more precise estimated time slot. You'll also get a notification when you are next on the list.`}
      />
    )}
    <InstructionRow
      icon='Calendar'
      title={t`We are preparing your appointment`}
      description={
        isStationary
          ? // eslint-disable-next-line noddi/no-banned-ui-terms -- consumer copy: end customers read 'technician'; 'worker' is the backoffice term
            t`Our team is preparing your tires and assigning your appointment to a skilled technician. You don't need to do anything — just come to the station at the scheduled time.`
          : // eslint-disable-next-line noddi/no-banned-ui-terms -- consumer copy: end customers read 'technician'; 'worker' is the backoffice term
            t`Our team is preparing your tires and assigning your appointment to a skilled technician. You don't need to do anything — just make sure the car is available around the scheduled time.`
      }
    />
  </NoddiBasicCard>
);
